import { createMongoAbility } from '@casl/ability';
import { type CanProps, AbilityProvider as CaslAbilityProvider, Can as CaslCan } from '@casl/react';
import { useAbility } from '@mdvip/shared/stores/authStore';
import type { AppAbility } from '@mdvip/shared/types/ability';
import type { ReactNode } from 'react';

// Module-level instance — shared across renders so context value identity is
// stable when ability is null (prevents unnecessary subscriber re-renders).
const DENY_ALL_ABILITY = createMongoAbility<AppAbility>([]);

// Type-narrowed re-export of @casl/react's Can — pins the ability tuple to
// AppAbility so `I` and `a` props are compile-time-checked against our
// Action/Subject unions instead of falling back to the unconstrained
// AnyAbility shape (any string).
export const Can = CaslCan as (props: CanProps<AppAbility>) => ReactNode;

// Bridges the Zustand auth store to @casl/react's context. State source of
// truth stays in the store; this Provider is dependency injection so <Can>
// can read the current ability without consumers touching the context.
export function AbilityProvider({ children }: { children: ReactNode }) {
  const ability = useAbility();
  return <CaslAbilityProvider value={ability ?? DENY_ALL_ABILITY}>{children}</CaslAbilityProvider>;
}
